import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
export const constantRoutes = [
	{
	  path: '/',
	  component: () => import('@/index')
	},
	{
	  path: '/home',
	  component: () => import('@/home')
	},
	{
	  path: '/custom',
	  component: () => import('@/view/custom/N18212')
	},
]
const createRouter = () =>
  new Router({
    mode: 'hash', // require service support
    routes: constantRoutes
  })

const router = createRouter()
export default router
